import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { ErrorBoundary } from "@widgets/layouts/index.jsx";
import { PropertyAccordion } from "./accordion/index.jsx";
import { PropertyTabs } from "./index.jsx";
import { PropertyHeader } from "./header/index.jsx";

import styles from "./styles.css";

const Property = ({ children, id = "", className }) => {
  return (
    <div id={id} className={`${styles.propertyWrapper} ${className}`}>
      {children}
    </div>
  );
};
Property.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string
};

const PropertyPane = ({ children, className }) => {
  return (
    <div className={`${styles.propertyPane} ${className}`}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  );
};
PropertyPane.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
Property.Header = PropertyHeader;
Property.Tabs = PropertyTabs;
Property.Pane = PropertyPane;
Property.Accordion = PropertyAccordion;

export { Property, PropertyAccordion, PropertyHeader };

/**
 * <Property>
 *  <Property.Header>
 *    <Property.Header.Name />
 *    <Property.Header.Delete />
 *  </Property.Header>
 *  <Property.Tabs>
 *    <Property.Tabs.Tab></Property.Tabs.Tab>
 *    <Property.Tabs.Tab></Property.Tabs.Tab>
 * </Property.Tabs>
 * <Property.Pane>
 *    <Property.Accordion>
 *        <Property.Accordion.Panel />
 *        <Property.Accordion.Panel />
 *    </Property.Accordion>
 * </Property.Pane>
 * </Property>
 */

export { ColorProperty, ColorPaletteProperty } from "./color/index.jsx";
export { DropdownProperty } from "./dropdown/index.jsx";
export { SingleDimensionProperty } from "./singledimension/index.jsx";
export { MultiDimensionProperty } from "./multidimension/index.jsx";
export { NumberProperty } from "./number/index.js";
export { BorderRadiusProperty } from "./multidimension/borderradius.jsx";
export { BorderWidthProperty } from "./multidimension/borderwidth.jsx";
export { PaddingProperty } from "./multidimension/padding.jsx";
export { MarginProperty } from "./multidimension/margin.jsx";
export {
  DIMENSION_INPUT_SIZE,
  DimensionInput
} from "./elements/dimensioninput.jsx";
export { TextStyleProperties, TEXT_STYLE_VALUES } from "./textstyles/index.jsx";
export { PropertyTabs } from "./propertytab/index.jsx";
export { PropertiesField } from "./field/index.jsx";
export { StateChanger } from "./statechanger/index.jsx";
// View builder primitives
export * from "./general/index.jsx";
